import { apiSlice } from '../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['packages'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllPackages: builder.query({
        query: (fishery_id) => ({
          url: 'booking/fishery/reservation-packages',
          method: 'GET',
          params: { fishery_id },
        }),
        providesTags: ['packages'],
      }),
      getRefundList: builder.query({
        query: (data) => ({
          url: 'ops/refund_details',
          method: 'post',
          data,
        }),
        providesTags: ['refundList'],
      }),
      updateRefundStatus: builder.mutation({
        query: (data) => ({
          url: 'ops/approve_refund',
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'refundList' }],
      }),

      createBrand: builder.mutation({
        query: (data) => ({
          url: 'ops/brands',
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'brands' }],
      }),
      updateBrand: builder.mutation({
        query: (data) => ({
          url: 'ops/brands/update-brand',
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'UpdateGiveaway' }],
      }),
      removeBrand: builder.mutation({
        query: (brand_id) => ({
          url: 'ops/brands',
          method: 'delete',
          params: { brand_id },
        }),
        invalidatesTags: (result, error, { quiz_id }) => [{ type: 'brands' }],
      }),
    }),
  });

export const {
  useCreateBrandMutation,
  useGetAllPackagesQuery,
  useUpdateBrandMutation,
  useRemoveBrandMutation,
  useGetRefundListQuery,
  useUpdateRefundStatusMutation,
} = extendedApiSlice;
